export default __webpack_public_path__ + "scrollwindow-left.5cb2b4.png";